<template>
  <div class="page-wrapper">
    <!--轮播 -->
    <el-carousel trigger="click" height="375px" width="100%" indicator-position="none" arrow="never" autoplay="false">
      <el-carousel-item v-for="(item, index) in 1" :key="item">
        <img src="@/assets/newImage/合作图片@2x.png" class="banner-img" />
      </el-carousel-item>
    </el-carousel>
    <div class="content-view">

      <div class="contact-info">
        <div class="cooperation-text">
          随着我司业务种类的不断增加，领点回收网平台</br>也将诚招符合公司价值观的商家合作，希</br>望能与您一起共筑美好的未来。</br>
          合作电话：19272927776（企业合作、话</br>费卡、加油卡、游戏卡、等多项预付卡）</br>
          合作微信：zyf2096xx</br>
          合作邮箱：zyf802@qq.com</br>
          商户网站：https://www.hblingdian.cn</br>
        </div>
      </div>
      <div class="service-info">
        <div class="qr-code">
<!--          <vue-qr :text="wechat" :size="150" :margin="10"></vue-qr>-->
          <img src="@/assets/image/企微商务客服.png" :width="150" :margin="10"/>
        </div>
        <div class="service-text">
          <div style="display: flex;align-items: center;">
            <img src="../assets/newImage/客服 (5)@2x.png"  style="width:42px ; height: 42px;"  alt="">
            <div class="service-title">联系商务客服</div>
          </div>

          <div class="service-time">工作时间：9:00 - 23:00</div>
        </div>
      </div>
    </div>
    <div style="height: 20px;"></div>
    <floatingSidebar></floatingSidebar>
  </div>
</template>

<script>
import vueQr from "vue-qr";
import floatingSidebar from "../components/base/floating-sidebar.vue";
export default {
  components: {
    floatingSidebar,
    vueQr
  },
  data() {
    return {
      wechat: "",
      arr: require("@/assets/newImage/合作ba@2x.png"),
    };
  },
  mounted() {
    // 从localStorage获取wechat
    this.wechat = localStorage.getItem('wechat') || '';
  },
};
</script>

<style lang="scss" scoped>
.page-wrapper {
  background-color: #ECF2FE;

  .banner-img {
    height: 375px;
    width: 100%;
    // object-fit: cover;
  }

  .content-view {
    margin: 50px 120px;
    padding: 40px;
    background: #FFFFFF;
    border-radius: 31px;
    display: flex;

    .cooperation-text {
      font-size: 22px;
      line-height: 1.6;
      color: #000000;
      max-width: 800px;
    }

    .contact-info {
      display: flex;
      flex-direction: column;
      justify-content: center;
      flex: 1;
      align-items: center;

    }

    .service-info {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 20px;
      flex: 1;

      .qr-code {
        width: 177px;
        height: 177px;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .service-text {
        text-align: center;

        .service-title {
          margin-left: 10px;
          font-size: 16px;
          color: #333;
          margin-bottom: 8px;
        }

        .service-time {
          margin-top: 10px;
          font-size: 14px;
          color: #666;
        }
      }
    }
  }
}
</style>
